// @flow
import Store from 'store';
import {pushDataLayer} from '@optimaxdev/analytics/mobile';
import type {SagaIterator} from 'redux-saga';

import {BRONTO_CONTACT_EID, BRONTO_MAGENTO_ID} from 'constants/bronto/bronto';

import {call, put, select} from 'redux-saga/effects';
import {visibilityMenu} from 'actions/menu/mainMenu';
import {fetchStoreInfo} from 'reducers/storeInfo/storeInfo';
import {getUrlParameter} from 'libs/url';
import {getStoreInfoState} from 'selectors/storeInfo/storeInfo';

/**
 * Save subscriber id to local storage
 * Very important! Please be careful!
 */
export function* saveSubscriberIdFromUrl(): SagaIterator {
    const contactEidFromUrl = yield call(getUrlParameter, 'contact_eid');
    if (contactEidFromUrl) yield call([Store, 'set'], BRONTO_CONTACT_EID, contactEidFromUrl);

    const magentoIdFromUrl = yield call(getUrlParameter, 'magento_subsciber_id');
    if (magentoIdFromUrl) yield call([Store, 'set'], BRONTO_MAGENTO_ID, magentoIdFromUrl);
}

/**
 * Listener for changing page
 * Call initial requests
 */
export function* helpersForChangePage(): SagaIterator {
    // remove interval from cms block
    yield call(clearTimeout, window.highestTimeoutCmsId);

    // save subscriber id to local storage
    yield call(saveSubscriberIdFromUrl);

    // hide menu
    const visibilityMenuAction = yield call(visibilityMenu, false);
    yield put(visibilityMenuAction);

    // scroll to top page
    yield call(window.scrollTo, 0, 0);
}

/**
 * Call page analytic
 */
export function* changePageAnalyticSaga(): SagaIterator {
    yield call(pushDataLayer, {event: 'virtualPageView'});
}

/**
 * Load store info
 */
export function* loadStoreInfo(): SagaIterator {
    const storeInfo = yield select(getStoreInfoState);
    if (storeInfo.status !== 'fulfilled') {
        const getStoreInfoAction = yield call(fetchStoreInfo);
        yield put(getStoreInfoAction);
    }
}

/**
 * Listener for changing page
 * Call initial requests
 */
export function* actionsForChangePage(): SagaIterator {
    yield call(helpersForChangePage);
    yield call(changePageAnalyticSaga);
}
